import type { StructureEdge, StructureNode } from '@tf/shared/lib/account/AccountStructure/utils';
import { Box, TFCard } from '@tf/ui';
import type React from 'react';

import { AccountStructure } from '@/components/shared';

interface AccountStructure {
	nodes: StructureNode[];
	edges: StructureEdge[];
}

interface Props {
	accountStructure: AccountStructure;
	children?: React.ReactNode;
}

export const ReviewStructureStep: React.FC<Props> = ({ accountStructure, children }) => {
	return (
		<TFCard w="100%" innerPadding="1.5rem">
			{children}
			<Box w="100%" h="700px" sx={{ flex: 1 }}>
				<AccountStructure accountStructure={accountStructure} />
			</Box>
		</TFCard>
	);
};
